import { ROUTES } from "./";

export const MANAGE_FEE_ROUTES = {
  MANAGE_FEE: `${ROUTES.FEE}/manage-fee`,
  SPECIFICATION_INFORMATION: `${ROUTES.FEE}/specification-information`,
  FEE_RUN: `${ROUTES.FEE}/fee-run`,
  CREATE_SPECIFICATION_INFORMATION: `${ROUTES.FEE}/create-specification-information`,
  BASIC_DETAILS: `${ROUTES.CREATE_FEE}/basic-details`,
  CALCULATION: `${ROUTES.CREATE_FEE}/calculation`,
  APPLICABLE_TO: `${ROUTES.CREATE_FEE}/applicable-to`,
  SCHEDULE_OR_RUN: `${ROUTES.CREATE_FEE}/schedule-or-run`,
  SUMMARY: `${ROUTES.CREATE_FEE}/summary`,
  FEE_RUN_DETAILS: `${ROUTES.FEE_RUN}/fee-run-details`,
  FEE_RUN_PARTICIPANT_DETAILS: `${ROUTES.FEE_RUN}/participant-details`,
};

export const MANAGE_FEE_MENU = [
  {
    id: "manageFee",
    label: "Manage Fee",
    path: MANAGE_FEE_ROUTES.MANAGE_FEE,
    contentHeader: "Manage Fee",
    breadCrumbs: [],
  },
  {
    id: "specificationInformation",
    label: "Specification Information",
    path: MANAGE_FEE_ROUTES.SPECIFICATION_INFORMATION,
    contentHeader: "Manage Specification Information",
    breadCrumbs: [],
  },
  {
    id: "feeRun",
    label: "Fee Run",
    path: MANAGE_FEE_ROUTES.FEE_RUN,
    contentHeader: "Fee Run Listing",
    breadCrumbs: [],
  },
];

export const CREATE_FEE_MENU = [
  {
    id: "basicDetails",
    label: "Basic Details",
    step: 1,
    path: MANAGE_FEE_ROUTES.BASIC_DETAILS,
    contentHeader: "Basic Details",
    breadCrumbs: [],
  },
  {
    id: "calculation",
    label: "Calculation",
    step: 2,
    path: MANAGE_FEE_ROUTES.CALCULATION,
    contentHeader: "Calculation",
    breadCrumbs: [],
  },
  {
    id: "applicableTo",
    label: "Applicable To",
    step: 3,
    path: MANAGE_FEE_ROUTES.APPLICABLE_TO,
    contentHeader: "Applicable To",
    breadCrumbs: [],
  },
  {
    id: "scheduleOrRun",
    label: "Schedule / Run",
    step: 4,
    path: MANAGE_FEE_ROUTES.SCHEDULE_OR_RUN,
    contentHeader: "Schedule / Run",
    breadCrumbs: [],
  },
  {
    id: "summary",
    label: "Summary",
    step: 5,
    path: MANAGE_FEE_ROUTES.SUMMARY,
    contentHeader: "Summary",
    breadCrumbs: [],
  },
];

export const ALL_MANAGE_FEE_ROUTES = [...MANAGE_FEE_MENU, ...CREATE_FEE_MENU];

export const manageFeeFormNames = {
  CALCULATION: "calculation",
  MANAGE_SPECIFICATION_INFORMATION: "manage specification information",
  CREATE_SPECIFICATION_INFORMATION: "create specification information",
  FEE_BASIC_DETAILS: "fee basic details",
  FEE_FILTER_FORM: "fee filter form",
  FEE_RUN_SEARCH: "fee run search",
  APPLICABLE_TO: "applicable to",
  SCHEDULE_OR_RUN: " schedule or run",
};

export const feeFormFields = {
  [manageFeeFormNames.FEE_BASIC_DETAILS]: {
    name: "name",
    description: "description",
    feeClassification: "feeClassification",
    feeStatus: "feeStatus",
    feeClassificationName: "feeClassificationName",
  },
  [manageFeeFormNames.FEE_RUN_SEARCH]: {
    searchString: "searchString",
    from: "from",
    numberOfRecordsToBeFetched: "numberOfRecordsToBeFetched",
    startDate: "startDate",
    endDate: "endDate",
  },
  [manageFeeFormNames.FEE_FILTER_FORM]: {
    feeType: "feeType",
    feeClassificationIds: "feeClassificationIds",
    feeRunType: "feeRunType",
    feeStatus: "feeStatus",
    planId: "planId",
    planNameOrId: "planNameOrId",
    searchString: "searchString",
  },
  [manageFeeFormNames.MANAGE_SPECIFICATION_INFORMATION]: {
    specificationName: "specificationName",
    feesType: "feesType",
    allocationType: "allocationType",
    //  id: "id"
  },
  [manageFeeFormNames.CREATE_SPECIFICATION_INFORMATION]: {
    feeType: "feeType",
    feeToBeCollectedFromOnlySelectedInvestment:
      "feeToBeCollectedFromOnlySelectedInvestment",
    processMinAmount: "processMinAmount",
    minimumThresholdBalance: "minimumThresholdBalance",
    percentageOfAccountBalanceAvailable: "percentageOfAccountBalanceAvailable",
    excludeFullyPaidOutParticipants: "excludeFullyPaidOutParticipants",
    runFeeFor: "runFeeFor",
    includeLoanBalancesInAssetComputation:
      "includeLoanBalancesInAssetComputation",
    id: "id",
    // specificationId: "specificationId",
    feeSpecificationId: "feeSpecificationId",
    feeAmount: "feeAmount",
    investmentName: "investmentName",
    investmentId: "investmentId",
    specificationName: "specificationName",
    allocationType: "allocationType",
    feeSpecification: "feeSpecification",
    name: "name",
    description: "description",
    allocationSubType: "allocationSubType",
    participantAllocation: "participantAllocation",
    tierBasis: "tierBasis",
    tierComputationType: "tierComputationType",
    feePercentageOrBasisPoints: "feePercentageOrBasisPoints",
    investmentType: "investmentType",
    collectOnlyFromThisInvestment: "collectOnlyFromThisInvestment",
    feeTiers: "feeTiers",
    tierComputationSubType: "tierComputationSubType",
    formulaType: "formulaType",
  },
  [manageFeeFormNames.CALCULATION]: {
    feeType: "feeType",
    feeToBeCollectedFromOnlySelectedInvestment:
      "feeToBeCollectedFromOnlySelectedInvestment",
    processMinAmount: "processMinAmount",
    minimumThresholdBalance: "minimumThresholdBalance",
    percentageOfAccountBalanceAvailable: "percentageOfAccountBalanceAvailable",
    excludeFullyPaidOutParticipants: "excludeFullyPaidOutParticipants",
    runFeeFor: "runFeeFor",
    includeLoanBalancesInAssetComputation:
      "includeLoanBalancesInAssetComputation",
    id: "id",
    // specificationId: "specificationId",
    feeSpecificationId: "feeSpecificationId",
    feeAmount: "feeAmount",
    investmentName: "investmentName",
    investmentId: "investmentId",
    specificationName: "specificationName",
    allocationType: "allocationType",
    feeSpecification: "feeSpecification",
    name: "name",
    description: "description",
    allocationSubType: "allocationSubType",
    participantAllocation: "participantAllocation",
    tierBasis: "tierBasis",
    tierComputationType: "tierComputationType",
    feePercentageOrBasisPoints: "feePercentageOrBasisPoints",
    investmentType: "investmentType",
    collectOnlyFromThisInvestment: "collectOnlyFromThisInvestment",
    feeTiers: "feeTiers",
    tierComputationSubType: "tierComputationSubType",
    formulaType: "formulaType",
  },
  [manageFeeFormNames.APPLICABLE_TO]: {
    applicableTo: "applicableTo",
    planType: "planType",
    planMappings: "planMappings",
    allocationMethod: "allocationMethod",
    statusType: "statusType",
    advisor: "advisor",
    clearingPartner: "clearingPartner",
    planGroup: "planGroup",
    planGroupMappings: "planGroupMappings",
    excludedPlanMappings: "excludedPlanMappings",
    deductFeeFrom: "deductFeeFrom",
    investment: "investment",
  },

  [manageFeeFormNames.SCHEDULE_OR_RUN]: {
    feeRunType: "feeRunType",
    effectiveStartDate: "effectiveStartDate",
    effectiveEndDate: "effectiveEndDate",
    basisDate: "basisDate",
    basisAsOfDate: "basisAsOfDate",
    basisAsOfFrequency: "basisAsOfFrequency",
    scheduleType: "scheduleType",
    monthAnnually: "monthAnnually",
    dayAnnually: "dayAnnually",
    monthSemiAnnually: "monthSemiAnnually",
    daySemiAnnually: "daySemiAnnually",
    startDay: "startDay",
    firstDate: "firstDate",
    secondDate: "secondDate",
    monthQuarterly: "monthQuarterly",
    dayQuarterly: "dayQuarterly",
    startDayWeekly: "startDayWeekly",
    processTime: "processTime",
    feeProcess: "feeProcess",
    processDate: "processDate",
    processTimeHours: "processTimeHours",
    processTimeMinutes: "processTimeMinutes",
  },
};
